import React, {useContext} from "react";
import Title from "../../ui/title/Title";
import CityImg from './assets/city-number.svg';
import ReportImg from './assets/report.svg';
import RecallImg from './assets/recall.svg';
import AudioImg from './assets/audio.svg';
import BlacklistImg from './assets/blacklist.svg';
import List from "../../ui/list-item/List";
import Button from "../../ui/button/Button";
import CardPhoto from './assets/card-photo-2.png'
import TitleIcon from "./assets/phone-icon.svg";
import Card from "../../ui/card/Card";
import './Phone.css';
import { FormContext } from "../../app/App";

const benefitsData = [
    {class: 'image-item', wraper: 'benefit-wraper', img: CityImg, imageClass: 'city', title: 'Городской номер', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: ReportImg, imageClass: 'report', title: 'Отчет о звонках', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: RecallImg, imageClass: 'recall', title: 'Переадресация вызова', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: AudioImg, imageClass: 'audio', title: 'Аудиозапись', titleClass: 'image-title'},
    {class: 'image-item', wraper: 'benefit-wraper', img: BlacklistImg, imageClass: 'blacklist', title: 'Черный список', titleClass: 'image-title'},
]

const cardData = {img: CardPhoto, tarif: '600₽', measuring: '/мес', titleIcon: TitleIcon, classTitle: 'internet', title: "<span class='phone-card-title'>Безлимит</span><br> на все городские номера", benefits: ['Подробная он-лайн детализация звонков', 
                                                                                                                    'Абонентская линия - бесплатно',
                                                                                                                    'Цифровое качество связи']}

export default function Phone()
{
    const { os } = useContext(FormContext);
    return (
        <section id="phone"  className="main-phone">
            <p className={`background-line-phone ${os == 'android' ? 'android-phone': ''}`}>телефония</p>
            <div className="container">
                <Title props={ {type: 'section-title', title: 'Телефония'} } />
                <Card props={ cardData }/>
                <ul className="phone-list">
                    {benefitsData.map(benefit => {
                        return <List props={benefit}/>
                    })}
                </ul>
                <Button props={ {type: 'section-button', name: 'Оставить заявку', dataName: 'Телефония'} }/>
            </div>
        </section>
    )
}